// @ts-nocheck
// Helper function to assign colors based on values using gradients
export const getColorForValue = (value: number, forecastType: string, maxPowerValue = 5): string => {
  // Different color scales for different forecast types
  // debugger
  // console.log("forecastType", forecastType)
  if (forecastType === 'precipitation') {
    // Blue gradient for precipitation
    const min = 0;
    const max = 15;
    const normalizedValue = Math.min(Math.max((value - min) / (max - min), 0), 1);
    // Gradient from very light blue (#e3f2fd) to very dark blue (#082b61)
    const r = Math.round(227 - normalizedValue * (227 - 8));
    const g = Math.round(242 - normalizedValue * (242 - 43));
    const b = Math.round(253 - normalizedValue * (253 - 97));
    return `rgb(${r}, ${g}, ${b})`;
  }
  else if (forecastType === 'snowWater') {
    // Blue gradient for precipitation
    const min = 0;
    const max = 30;
    const normalizedValue = Math.min(Math.max((value - min) / (max - min), 0), 1);
    // Gradient from very light blue (#e3f2fd) to very dark blue (#082b61)
    const r = Math.round(227 - normalizedValue * (227 - 8));
    const g = Math.round(242 - normalizedValue * (242 - 43));
    const b = Math.round(253 - normalizedValue * (253 - 97));
    return `rgb(${r}, ${g}, ${b})`;
  }
  else if (forecastType === 'soilMoisture') {
    // Blue gradient for precipitation
    const min = 0;
    const max = 100;
    const normalizedValue = Math.min(Math.max((value - min) / (max - min), 0), 1);
    // Gradient from very light blue (#e3f2fd) to very dark blue (#082b61)
    const r = Math.round(227 - normalizedValue * (227 - 8));
    const g = Math.round(242 - normalizedValue * (242 - 43));
    const b = Math.round(253 - normalizedValue * (253 - 97));
    return `rgb(${r}, ${g}, ${b})`;
  }
  else if (forecastType === 'wind10m' || forecastType === 'wind80m') {
    // Blue to red gradient for wind power (MW)
    const min = 0;
    const max = 30; // Use the passed max value parameter
    const normalizedValue = Math.min(Math.max((value - min) / (max - min), 0), 1);
    
    // Gradient from light blue to red
    if (normalizedValue < 0.5) {
      // Light blue to yellow (0-50%)
      const factor = normalizedValue / 0.5;
      const r = Math.round(173 + factor * 82); // 173 to 255
      const g = Math.round(216 + factor * 39); // 216 to 255
      const b = Math.round(230 - factor * 180); // 230 to 50
      return `rgb(${r}, ${g}, ${b})`;
    } else {
      // Yellow to red (50-100%)
      const factor = (normalizedValue - 0.5) / 0.5;
      const r = Math.round(255);
      const g = Math.round(255 - factor * 205); // 255 to 50
      const b = Math.round(50 - factor * 20);  // 50 to 30
      return `rgb(${r}, ${g}, ${b})`;
    }
  } 
  else if (forecastType === 'windPower') {
    // Blue to red gradient for wind power (MW)
    const min = 0;
    const max = maxPowerValue; // Use the passed max value parameter
    const normalizedValue = Math.min(Math.max((value - min) / (max - min), 0), 1);

    // Gradient from light blue to red
    if (normalizedValue < 0.5) {
      // Light blue to yellow (0-50%)
      const factor = normalizedValue / 0.5;
      const r = Math.round(173 + factor * 82); // 173 to 255
      const g = Math.round(216 + factor * 39); // 216 to 255
      const b = Math.round(230 - factor * 180); // 230 to 50
      return `rgb(${r}, ${g}, ${b})`;
    } else {
      // Yellow to red (50-100%)
      const factor = (normalizedValue - 0.5) / 0.5;
      const r = Math.round(255);
      const g = Math.round(255 - factor * 205); // 255 to 50
      const b = Math.round(50 - factor * 20);  // 50 to 30
      return `rgb(${r}, ${g}, ${b})`;
    }
  }
  else if (forecastType === 'temperature') {
    // Blue to yellow to red gradient for temperature
    const min = -10;
    const max = 40;
    const normalizedValue = Math.min(Math.max((value - min) / (max - min), 0), 1);
    
    if (normalizedValue < 0.5) {
      // Blue to yellow (cold to warm)
      const factor = normalizedValue / 0.5;
      const r = Math.round(179 + factor * 76);
      const g = Math.round(229 + factor * 26);
      const b = Math.round(252 - factor * 193);
      return `rgb(${r}, ${g}, ${b})`;
    } else {
      // Yellow to red (warm to hot)
      const factor = (normalizedValue - 0.5) / 0.5;
      const r = Math.round(255);
      const g = Math.round(255 - factor * 172);
      const b = Math.round(59 + factor * 21);
      return `rgb(${r}, ${g}, ${b})`;
    }
  }
  else if (forecastType === 'humidity') {
    // Purple gradient for humidity (%)
    const min = 0;
    const max = 100;
    const normalizedValue = Math.min(Math.max((value - min) / (max - min), 0), 1);
    // Gradient from very light purple (#f3e5f5) to very dark purple (#4a148c)
    const r = Math.round(243 - normalizedValue * (243 - 74));
    const g = Math.round(229 - normalizedValue * (229 - 20));
    const b = Math.round(245 - normalizedValue * (245 - 140));
    return `rgb(${r}, ${g}, ${b})`;
  }
  else if (forecastType === 'solarL' || forecastType === 'solarS') {
    // Yellow to orange gradient for solar radiation
    const min = 0;
    const max = 1000;
    const normalizedValue = Math.min(Math.max((value - min) / (max - min), 0), 1);
    // Gradient from very light yellow (#fff9c4) to orange (#f57f17)
    const r = Math.round(255 - normalizedValue * (255 - 245));
    const g = Math.round(249 - normalizedValue * (249 - 127));
    const b = Math.round(196 - normalizedValue * (196 - 23));
    return `rgb(${r}, ${g}, ${b})`;
  }
  else if (forecastType === 'processed') {
    // Blue to yellow to red gradient for temperature
    const min = 0;  //change later?
    const max = maxPowerValue;
    const normalizedValue = Math.min(Math.max((value - min) / (max - min), 0), 1);
    
    if (normalizedValue < 0.5) {
      // Blue to yellow (cold to warm)
      const factor = normalizedValue / 0.5;
      const r = Math.round(179 + factor * 76);
      const g = Math.round(229 + factor * 26);
      const b = Math.round(252 - factor * 193);
      return `rgb(${r}, ${g}, ${b})`;
    } else {
      // Yellow to red (warm to hot)
      const factor = (normalizedValue - 0.5) / 0.5;
      const r = Math.round(255);
      const g = Math.round(255 - factor * 172);
      const b = Math.round(59 + factor * 21);
      return `rgb(${r}, ${g}, ${b})`;
    }
  }
  
  // Default color scheme (gray)
  return '#9e9e9e';
};